import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "gridIsShow", true);
        Vue.set(state, "formIsShow", false);
        Vue.set(state, "expenditureForm", false);
    },
    openForm(state) {
        state.formIsShow = true;
        state.gridIsShow = false;
        state.expenditureForm = false;
    },
    openTable(state) {
        state.formIsShow = false;
        state.gridIsShow = true;
        state.expenditureForm = false;
    },
    openExpenditureForm(state) {
        state.formIsShow = false;
        state.gridIsShow = false;
        state.expenditureForm = true;
    },
    modifyEuSzolgAzonositoToSelect(state, euszolgAzonosito) {
        let tempArray = state.eBeutaloHeaderFields;

        tempArray.map(item => {
            if(item.name === "ellatoIntezmenySzervezetiEgyseg") {
                item.selectOptions.additionalApiCallbackParams = {
                    euszolgAzonosito: euszolgAzonosito
                };
            }
            return item;
        })
    }
}
